import { RootState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

export const selectTestPlanExecuteResponses = (state: RootState) => state.testPlanSlice.testPlanExecuteResponses;

export const findTestPlanExecuteResponse = createSelector(
  [selectTestPlanExecuteResponses, (state: RootState, testCaseInternalId: string) => testCaseInternalId],
  (testPlanExecuteResponses, testCaseInternalId) => {
    return testPlanExecuteResponses.find(item => item.internalId === testCaseInternalId) || {
      responseBody: "",
      time: 0,
      statusCode: 0
    };
  }
);

export const selectScenarioExecuteResponses = (state: RootState) => state.scenarioSlice.scenarioExecuteResponses;

export const findScenarioExecuteResponse = createSelector(
  [selectScenarioExecuteResponses, (state: RootState, testCaseInternalId: string) => testCaseInternalId],
  (scenarioExecuteResponses, testCaseInternalId) => {
    return scenarioExecuteResponses.find(item => item.internalId === testCaseInternalId) || {
      responseBody: "",
      time: 0,
      statusCode: 0
    };
  }
);

export const selectProjectsSettings = (state: RootState) => state.mainSlice.projectsSettings;

export const findProjectSettings = createSelector(
  [selectProjectsSettings, (state: RootState) => state.mainSlice],
  (projectsSettings, state) => {
    return (state.login && state.projectName && projectsSettings[state.login][state.projectName]) || {
      selectedEnvironment: {
        id: 0,
        servers: [],
        testRunId: 0,
        name: "",
        defaultVariableValues: [],
        defaultHeaders: []
      },
      testrailEnable: true,
      name: state.projectName,
      selectedTab: 0,
    };
  }
);
